// src/components/WhatsAppButton.jsx
import React from 'react';
import { IconButton } from '@mui/material';
import { FaWhatsapp } from 'react-icons/fa'; // Import WhatsApp icon from react-icons

const WhatsAppButton = () => {
  const handleClick = () => {
    const phoneNumber = '+923425262121'; // Replace with your WhatsApp phone number
    const message = 'Hi, I need help!'; // Optional pre-filled message
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <IconButton
      onClick={handleClick}
      sx={{
        backgroundColor: '#25D366', // WhatsApp green color
        '&:hover': { backgroundColor: '#128C7E' }, // Darker shade on hover
        borderRadius: '50%',
        padding: '10px',
      }}
    >
      <FaWhatsapp size={30} color="white" /> {/* The icon size and color */}
    </IconButton>
  );
};

export default WhatsAppButton;